'use client';

const WhatIsIncludedSection = ({
  title,
  colordTitle = '',
  description,
  data,
}) => {
  const colors = [
    'bg-orange-200',
    'bg-purple-200',
    'bg-red-200',
    'bg-blue-200',
  ];

  return (
    <div>
      <section className="py-8 md:py-16 lg:py-24 bg-white" id="whatisincluded">
        <div className="max-w-screen-lg mx-5 lg:mx-auto">
          <div className="text-center mb-6 md:mb-8">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900">
              {title}
              <span className="text-colorOrange-700">{colordTitle}</span>
            </h2>
            <p>{description}</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 items-start justify-between mb-4 md:mb-6">
            {data.map((service, index) => (
              <div key={index}>
                <div className="flex justify-between">
                  <div
                    className={`rounded-3xl py-4 px-4 mr-4 h-16 ${
                      service.bgColor || colors[index % colors.length]
                    }`}
                  >
                    {service.icon}
                  </div>
                  <div>
                    <h5 className="font-semibold text-colorBlue-800 mb-1">
                      {service.title}
                    </h5>
                    <p>{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatIsIncludedSection;
